import { Styles } from "@chakra-ui/theme-tools";

export const styles: Styles = {
  global: {
    body: {
      fontFamily: "",
      color: "",
      bg: "",
      transitionProperty: "",
      transitionDuration: "",
      lineHeight: "",
    },
    "*::placeholder": {
      color: "",
    },
    "*, *::before, &::after": {
      borderColor: "",
    },
  },
};
